var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { clientComponentModuleId } from '../render-engine/render-engine.helper';
import { NotificationType } from '../../../services/basics/notification-client.service';
import { computedFrom } from 'aurelia-binding';
import { FormatterHelper } from '../../../utilities/format-helper';
import moment from 'moment';
import { BaseTemplate } from './base-template';
import { RouterConstants } from '../../../configuration/router.constants';
import { SyndicateKeyHelper } from '../../../services/modules/brand-client.service';
var BaseLottery = /** @class */ (function (_super) {
    __extends(BaseLottery, _super);
    function BaseLottery(lotteryClientService, router, tokenClientService, notificationClientService, i18N, hotLotteryClientService, dialogClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClientService) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.tokenClientService = tokenClientService;
        _this.notificationClientService = notificationClientService;
        _this.hotLotteryClientService = hotLotteryClientService;
        // chooseTickets: BaseChooseTickets;
        _this.syndicates = [];
        // this is used for css
        _this.isFirstTime = true;
        _this.requestPending = false;
        _this.animating = false;
        _this.defaultUserCurrencySymbol = tokenClientService.getUserCurrency().symbol;
        return _this;
    }
    Object.defineProperty(BaseLottery.prototype, "chooseTickets", {
        get: function () {
            return this._chooseTickets;
        },
        set: function (x) {
            this._chooseTickets = x;
            this.onChooseTicketsSet(x);
        },
        enumerable: false,
        configurable: true
    });
    BaseLottery.prototype.onChooseTicketsSet = function (x) {
        if (x && this.navigateToCartInternal) {
            // keep it permissive so templates don't need to know about the field
            x.navigateToCartInternal = this.navigateToCartInternal;
        }
    };
    BaseLottery.prototype.navigateToSyndicate = function (syndicate) {
        if (!this.tokenClientService.isPreview) {
            this.router.navigateToRoute(RouterConstants.RouteNames.Syndicate, {
                key: SyndicateKeyHelper.getKey(syndicate.name),
                syndicateId: syndicate.syndicateId,
                brandLotteryId: this.brandLotteryId
            });
            this.sendHeightToClient(this.lastKnownHeight + "px", false);
        }
    };
    Object.defineProperty(BaseLottery.prototype, "lotteryGroups", {
        get: function () {
            if (this.lottery && this.lottery.lotteryGroups)
                return this.lottery.lotteryGroups.map(function (x) { return ({ id: x.brandLotteryId, value: "x" + x.increaseRate }); });
            return null;
        },
        enumerable: false,
        configurable: true
    });
    BaseLottery.prototype.navigateToLottery = function (lottery) {
        var _this = this;
        if (this.isFromCart && lottery.lotteryId != this.lotteryId) {
            var confirmModel = {
                message: this.i18n.tr(this.key + "-dialog-confirm-message"),
                buttons: [{ buttonName: this.i18n.tr(this.key + "-dialog-cancel-button"), buttonAction: function () { _this.dialogClient.hide(); } },
                    {
                        buttonName: this.i18n.tr(this.key + "-dialog-confirm-button"), buttonAction: function () {
                            _this.isFromCart = false;
                            _this.navigate(lottery);
                        }
                    }]
            };
            this.dialogClient.show(clientComponentModuleId("dialogs/confirm-dialog"), confirmModel);
        }
        else {
            this.navigate(lottery);
        }
    };
    BaseLottery.prototype.navigate = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId
        }, { replace: true });
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
    };
    BaseLottery.prototype.navigateToFilteredResults = function () {
        this.router.navigateToRoute(RouterConstants.RouteNames.Results, { lotteryId: this.lottery.lotteryId });
    };
    BaseLottery.prototype.hideFAQ = function () {
        this.faqVisible = false;
        //$("router-view").css("overflow-y", "auto");
    };
    BaseLottery.prototype.showFAQ = function () {
        var _this = this;
        this.faqVisible = true;
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
        //$("router-view").css("overflow-y", "hidden");
        var oldOnPopState = window.onpopstate;
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            window.onpopstate = oldOnPopState;
            _this.hideFAQ();
        };
    };
    BaseLottery.prototype.detached = function () {
        _super.prototype.detached.call(this);
        //$("router-view").css("overflow-y", "auto");
    };
    BaseLottery.prototype.activate = function (params) {
        var promise = _super.prototype.activate.call(this, params);
        this.key = params.key;
        this.isSubscribe = params.isSubscribe;
        if (params && params.cartGuid) {
            this.cartGuid = params.cartGuid;
        }
        if (params && params.isFromCart) {
            this.isFromCart = params.isFromCart;
        }
        if (params) {
            this.brandLotteryId = params.brandLotteryId;
            this.lotteryId = params.lotteryId;
        }
        if (params && params.draws) {
            this.draws = params.draws;
        }
        if (params && params.canRevert) {
            this.canRevert = params.canRevert;
        }
        if (params && params.isFromAgent) {
            this.isFromAgent = params.isFromAgent;
        }
        return this.getClientLottery(this.lotteryId, this.brandLotteryId, params.brandLotteryId, promise);
    };
    BaseLottery.prototype.getClientLottery = function (lotteryId, brandLotteryId, paramsBrandLotteryId, promise) {
        var _this = this;
        this.requestPending = true;
        var lotteryPromise = this.lotteryClientService.getClientLottery({
            brandLotteryId: brandLotteryId,
            lotteryId: lotteryId
        }).then(function (lotteryResult) {
            _this.lottery = lotteryResult;
            _this.brandLotteryId = lotteryResult.brandLotteryId;
            _this.brandLotterySliderValue = _this.brandLotteryId;
            if (!paramsBrandLotteryId)
                _this.loadBrandLotterySyndicates(brandLotteryId);
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        if (paramsBrandLotteryId)
            this.loadBrandLotterySyndicates(brandLotteryId);
        this.hotLotteryClientService.getHotLotteries().then(function (x) {
            _this.hotLotteries = x;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return new Promise(function (resolve, reject) { return Promise.all([promise, lotteryPromise]).then(function (x) {
            _this.requestPending = false;
            resolve();
        }, reject); });
    };
    BaseLottery.prototype.switchValueChanged = function (event) {
        var isChecked = event.detail.value;
        if (isChecked)
            this.changeLottery({ detail: { value: this.lotteryGroups[1].id, loaded: function (any) { } } });
        else
            this.changeLottery({ detail: { value: this.lotteryGroups[0].id, loaded: function (any) { } } });
    };
    BaseLottery.prototype.sliderValueChanged = function (event) {
        this.changeLottery(event);
    };
    BaseLottery.prototype.changeLottery = function (event) {
        var brandLotteryId = event.detail.value;
        if (!this.requestPending && this.lotteryGroups) {
            var lotteryGroup = this.lottery.lotteryGroups.filter(function (x) { return x.brandLotteryId == brandLotteryId; })[0];
            if (lotteryGroup) {
                this.key = this.getLotteryKey(lotteryGroup.lotteryName);
                this.getClientLottery(lotteryGroup.lotteryId, brandLotteryId, null, null).then(function (x) { event.detail.loaded(); });
            }
        }
    };
    BaseLottery.prototype.loadBrandLotterySyndicates = function (brandLotteryId) {
        var _this = this;
        this.lotteryClientService.getBrandLotterySyndicates({
            brandLotteryId: brandLotteryId,
            brandId: this.tokenClientService.user.brandId
        }).then(function (x) {
            _this.syndicates = x;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseLottery.prototype.attached = function () {
        var _this = this;
        _super.prototype.attached.call(this);
        if (this.chooseTickets && this.isFromAgent) {
            // first show page and then load dialog
            setTimeout(function () {
                _this.chooseTickets.showClientDetailsDialog();
            });
        }
    };
    BaseLottery.prototype.getAdditionalInfo = function () {
        return this.lotteryClientService.getLotteryAdditionalInfo(this.lotteryId);
    };
    Object.defineProperty(BaseLottery.prototype, "prize", {
        get: function () {
            if (this.lottery) {
                return FormatterHelper.getformattedValue(this.lottery.totalJackpot, navigator.language, 2);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLottery.prototype, "date", {
        get: function () {
            //14th March at 4pm
            if (this.lottery) {
                return this.lottery.drawDate ? moment(new Date(this.lottery.drawDate)).format("Do MMMM [at] h:mm a") : null;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLottery.prototype, "hideLotteriesSideGradient", {
        get: function () {
            if (this.lotteriesScroller) {
                if (this.lotteriesScroller.offsetWidth + this.lotteriesScroller.scrollLeft > this.lotteriesScroller.scrollWidth - 50) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    BaseLottery.prototype.previous = function () {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(this.carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_1 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_1; idx++) {
                accumulator += $(liCollection[idx]).outerWidth();
                if (accumulator - currentScrollLeft > 5) {
                    break;
                }
            }
            if (scrollElement.get(0)) {
                var newScrollLeft = currentScrollLeft - $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    BaseLottery.prototype.next = function () {
        var _this = this;
        if (this.animating) {
            return;
        }
        var scrollElement = $(this.carouselBar);
        if (scrollElement) {
            var currentScrollLeft = scrollElement.scrollLeft();
            var liCollection = scrollElement.children();
            var length_2 = liCollection.length;
            var accumulator = 0;
            for (var idx = 0; idx < length_2; idx++) {
                var width = $(liCollection[idx]).outerWidth();
                accumulator += width;
                if (accumulator - currentScrollLeft > width * 3) {
                    break;
                }
            }
            if (scrollElement.get(0)) {
                var newScrollLeft = currentScrollLeft + $(liCollection[idx]).outerWidth();
                this.animating = true;
                scrollElement.animate({
                    scrollLeft: newScrollLeft
                }, "linear", function () {
                    _this.animating = false;
                });
            }
        }
    };
    __decorate([
        computedFrom("lottery", "lottery.lotteryGroups"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseLottery.prototype, "lotteryGroups", null);
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], BaseLottery.prototype, "prize", null);
    __decorate([
        computedFrom("lottery"),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], BaseLottery.prototype, "date", null);
    return BaseLottery;
}(BaseTemplate));
export { BaseLottery };
